const state = {};

const getters = {};

const mutations = {};

export default {
  state,
  getters,
  mutations
};
